import * as React from 'react';
import {ContentHeader} from '@deviceinsight/ng-ui-components';
import {size} from 'lodash';

import {getPlatformStatus} from '../../api/servicestatusApi';
import {ServiceStatus} from '../../modules/servicestatus/types';
import ServiceStatusOverview from './ServiceStatusOverview';
import ServiceStatusAccordion from './ServiceStatusAccordion';

import './servicestatus.css';

const SERVICE_STATUS_TITLE = {
	id: 'route.label.servicestatus.name',
	defaultValue: 'NG Services'
};
const INSIGHTS_TITLE = {
	id: 'route.label.insights.name',
	defaultValue: 'Insights'
};
const badgeLabelStyle = {
	margin: '0 0 0 10px',
	backgroundColor: '#ddd',
	borderColor: 'transparent'
};

const ServiceStatusWrapper = () => {
	const [accordionClass, setAccordionClass] = React.useState('');
	const [activeFilter, setActiveFilter] = React.useState('');
	const [platformStatus, setPlatformStatus] = React.useState<Array<ServiceStatus>>([]);

	React.useEffect(() => {
		getPlatformStatus().then((status) => {
			setPlatformStatus(status);
		});
	}, []);

	const onChangeFormat = React.useCallback((className: string) => {
		setAccordionClass(className);
	}, []);

	const onFilterServices = React.useCallback((status: string) => {
		setActiveFilter((currentFilter) => (currentFilter === status ? '' : status));
	}, []);

	if (!platformStatus) return null;

	return (
		<React.Fragment>
			<ContentHeader title={SERVICE_STATUS_TITLE}>
				<span className="di label" style={badgeLabelStyle}>
					{size(platformStatus)}
				</span>
				<div className="di header-toolbar">
					<span
						className={!accordionClass ? 'tool view-xl selected' : 'tool view-xl'}
						onClick={() => onChangeFormat('')}
					/>
					<span
						className={accordionClass ? 'tool view-xs selected' : 'tool view-xs'}
						onClick={() => onChangeFormat('size-xs')}
					/>
				</div>
			</ContentHeader>
			<div className="ng-services">
				<div className="ng-services dash">
					<ServiceStatusOverview
						activeFilter={activeFilter}
						platformStatus={platformStatus}
						filterServices={onFilterServices}
						data-testid="service-status-overview"
					/>
				</div>
				<ContentHeader title={INSIGHTS_TITLE} />
				<ServiceStatusAccordion
					activeFilter={activeFilter}
					accordionClass={accordionClass}
					platformStatus={platformStatus}
					data-testid="service-status-accordion"
				/>
			</div>
		</React.Fragment>
	);
};

export default ServiceStatusWrapper;
